export default "__VITE_ASSET__RkfblgMV__"